<template>
<div>
    <div class="container" v-show="quiz">
      <div class="heading-content-title">
        <template v-if="step=='listening_practice'">{{ $t('lesson.listening_practice.title') }}</template>
        <template v-else-if="step=='exam'">{{ $t('lesson.exam.title') }}</template>
        <template v-else>{{ $t('lesson.question.title') }}</template>
        <div class="heading-content-right" v-for="(question,index) in questionList" :key="index" v-show="quiz">
          <div class="progress">{{b}}/{{questions.length}}</div>
          <!-- Lives -->
          <div class="lives">
            <div class="icon-life" :class="(lives_cnt >= 1) ? 'star-available' : 'star-spent'"></div>
            <div class="icon-life" :class="(lives_cnt >= 2) ? 'star-available' : 'star-spent'"></div>
            <div class="icon-life" :class="(lives_cnt >= 3) ? 'star-available' : 'star-spent'" v-if="lives_cnt==3"></div>
          </div>
        </div>
      </div>
      
      <div class="quiz-box" v-for="(question,index) in questionList" :key="index" v-show="quiz">
      
      
        <!-- Question -->
        <div class="questions-combined">
          <div class="box-question-explanation" @click="changeTrans(selectedLanguage.key)">
            <p v-show="!trans_instruction" v-html="question.instruction"></p>
            <p v-show="trans_instruction" v-html="question[selectedLanguage.key + '_instruction']"></p>
          </div>
  
          <div class="box-question">
            <p v-html="question.question"></p>
          </div>
        </div>

        <!-- Answer Choices -->
        <div class="box-propositions">
          <ul>
            <li v-for="(proposition,index) in question.propositions" :key="index" class="button button-choice" @click="selectResponse(proposition,index)" :class=" answered ? check(proposition, index) : ''" v-html="`${index + 1}. ` + proposition.props">
            </li>
          </ul>
        </div>
      
      

        <!-- progress -->
        <div class="question-progress" v-if="quiz && (step=='practice' || step=='exam')">
          <div class="progress-label">
            <div class="label-progress"><p>{{ timeLeft }}</p> sec.left</div>
          </div>
          <div class="progress-bar">
            <div class="progress-rate" :style="{ width: timeRemaining + '%' }"></div>
          </div>
        </div>
      </div>
      
      <!-- Buttons for Audio -->
      <div v-if="quiz">
        <lessonmultiaudio ref="lessonmultiaudio" v-if="isListening && audios && audioType=='audio'" :audioList="audios" :audioType="audioType" :driver="driver" :coachStep="coachStep" :hasAudioEl="hasAudioEl" @playevent="audioPlayEvent"></lessonmultiaudio>
      </div>

      <!-- Footer -->
      <div class="footer-quiz">
        <div class="box-button button-next-done" v-if="quiz" > 
            <button class="button" @click="nextQuestion()" :class="answered ? 'button-primary' : 'disabled'">{{ $t('common.button.next') }}</button>
        </div>
      </div>
      
      
    </div>


    <div class="container score" v-if="!quiz">
      <div class="heading-content-title">
        <template v-if="step=='listening_practice'">{{ $t('lesson.listening_practice.title') }}</template>
        <template v-else-if="step=='exam'">{{ $t('lesson.exam.title') }}</template>
        <template v-else>{{ $t('lesson.question.title') }}</template>
      </div>
      <div class="box-score">
        <div class="image-score" :class="score_result"></div>
        <div class="score-result" :class="score_result">{{ $t('lesson.question.score.title') }} <p class="score-shown"><span class="score-count">{{score}}</span>/{{questions.length}}</p></div>
        
        <p class="message">
        <template v-if="score_result == 'perfect'">
          {{ $t('lesson.question.score.perfect.message_1') }}<br>
          {{ $t('lesson.question.score.perfect.message_2') }}
        </template>
        <template v-else-if="score_result == 'pass'">
          {{ $t('lesson.question.score.pass.message_1') }}
        </template>
        <template v-else-if="score_result == 'failure'">
          {{ $t('lesson.question.score.failure.message_1') }}
        </template>
        
        </p>
      </div>
    </div>
    
</div>

</template>

<script>

import {appEnv, useCoachmark} from './../../config';

import questionLog from '../../mixins/question-log';
import {mapGetters} from 'vuex';

import LessonMultiAudio from './LessonMultiAudio.vue'

import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';

export default {
  mixins: [questionLog],
  name: "LessonQuestion",
  components: {
    'lessonmultiaudio': LessonMultiAudio,
  },
  props: {
    step: {
      type: String,
      required: true
    },
    questions: {
      type: Array,
      required: true
    },
    audios: {
      type: Array
    },
  },
  data(){
    return{
      audioType: 'audio',

      a:0,
      b:1,
      next:true,
      quiz:true,
      score:0,
      progress:0,
      count_timer:null,
      answered:false,
      // next_step:false,
      correct_answerd:false,
      incorrect_answerd:null,
      score_result:null,

      lives_cnt:3,
      timeLimit: 30,
      timePassed: 0,
      fullDashArray: 283,
      colorCodes: {
        info: {
          color: "green"
        },
        warning: {
          color: "orange",
          threshold: 15
        },
        alert: {
          color: "red",
          threshold: 10
        }
      },

      trans_instruction:false,
      authUser: null,
      driver: null,
      coachStep: 0,
      hasAudioEl: false,
      storage: {},
      
      questionCount: 0,
    }
  },
  computed: {
    ...mapGetters([
      'selectedLanguage'
    ]),
    isListening() {
      if (this.step == 'listening_practice') {
        return true;
      }
      return false;
    },
    timeLeft() {
      return this.timeLimit - this.timePassed
    },
    timeRemaining() {
      return (this.timePassed / this.timeLimit) * 100
    },
    questionList () {
      const questionSlise = this.questions.slice(this.a,this.b)
      
      return _.map(questionSlise, (value, index) => {
        let newQuestion = _.cloneDeep(value)
        newQuestion.propositions = _.shuffle(newQuestion.propositions)
        return newQuestion
      })
    }
  },

  watch: {
    answered() {
      if (!this.isListening) {return}
      if (this.answered) {
        this.$refs.lessonmultiaudio.pauseAudio();
      }
    },
    quiz() {
      if (!this.isListening) {return}
      if (!this.quiz) {
        this.$refs.lessonmultiaudio.stopAudio();
      }
    },

  },
  
  created() {
      this.authUser = this.$store.getters.getAuthUser;
      if(this.driver) {
        this.driver.reset();
      } else {
        this.initCoachMark();
      }
      this.answered = false
      
      
      this.questionCount = this.$store.getters.lesson_content[this.step].content.questions ? this.$store.getters.lesson_content[this.step].content.questions.length : 0
      
      if(this.questionCount <= 3) {
        this.lives_cnt = 2
      }
  },

  mounted() {
    
    if(useCoachmark) {
      this.storage = (appEnv === 'production') ? window.localStorage : window.sessionStorage
      
      const isCoachmarkDone = this.storage.getItem("coachmarkdone") ? JSON.parse(this.storage.getItem("coachmarkdone")) : null;
      if(!(isCoachmarkDone && this.step in isCoachmarkDone && isCoachmarkDone[this.step])) {
        this.showCoachMark();
      } else {
        this.progress = (100/this.questions.length);
        if (!this.isListening) {
          this.countTime();
        }
      }
        
    } else {
      this.progress = (100/this.questions.length);
      if (!this.isListening) {
        this.countTime();
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.count_timer);
  },
  methods: {
    changeTrans(key) {
      if(this.driver) {
        this.driver.reset();
      }
      if (key !== 'ja') {
        this.trans_instruction = !this.trans_instruction
      }
    },

    countTime() {
      let ref = this;
      
      if (this.answered) return false;
      
      ref.count_timer = setInterval(function(){
        ref.timePassed++;
        if(ref.timeLimit <= ref.timePassed) {
          clearInterval(ref.count_timer);
          ref.lives_cnt--;
          ref.answered = true;
          ref.nextQuestion();
        }
      }, 1000);
    },

    quizPropositions(quiz) {
      return _.shuffle(quiz.propositions)
    },

    selectResponse(e, index) {
      if(this.driver && (this.driver.hasHighlightedElement() || (this.hasAudioEl && this.coachStep <= 1))) {
        return false
      }
      
      if(this.count_timer) clearInterval(this.count_timer);

      if (this.answered) {
        return;
      }
      
      if (e.correct) {
        this.score++;
        this.correct_answerd = true;
        this.$store.dispatch('playSoundEffect', 'correct')
      } else {
        this.lives_cnt--;
        this.incorrect_answerd = index;
        this.$store.dispatch('playSoundEffect', 'incorrect')
      }
      this.answered = true;
    },

    check(status, index) {
      if (status.correct && this.correct_answerd) {
        return 'correct'
      } else if (this.incorrect_answerd == index) {
        return 'incorrect'
      } 
    },

    nextQuestion() {
      if(this.driver && (this.driver.hasHighlightedElement() || (this.hasAudioEl && this.coachStep <= 1))) {
        return false
      }
      
      if (!this.answered) {
        return;
      }

      // exam log
      let question_id = this.$store.getters.lesson_content[this.step].content.questions[this.a].question_id;
      let answered = (this.correct_answerd) ? true : false;
      let selected = (this.incorrect_answerd == null) ? this.incorrect_answerd : this.incorrect_answerd + 1;
      this.questionTempLog(question_id, answered, selected);
      
      if (this.lives_cnt <= 0) {
        this.quiz = false;
        this.score_result = 'failure';
        this.$emit('scoreresult', this.score_result)
        this.$emit('finquiz')
        
      } else if (this.questions.length - 1 == this.a) {
        this.quiz = false;
        // this.next_step = true;
        if (this.score == this.questions.length) {
          this.score_result = 'perfect';
        } else if (this.score <= 0) {
          this.score_result = 'failure';
        } else {
          this.score_result = 'pass';
        }
        this.lessonTempLog(this.score_result);
        
        this.$emit('scoreresult', this.score_result)
        this.$emit('finquiz')
        this.$emit('passedquiz')
        

        // Update Log
        this.questionLog()

      } else {
        this.progress = this.progress + (100/this.questions.length);
        this.a++;
        this.b++;
        this.timePassed = 0;
        this.answered = false;
        this.correct_answerd = false;
        this.incorrect_answerd = null;
        
        if (!this.isListening) {
          this.countTime();
        }
      }
    },

    restartQuiz(){
      let to = '';
      if (this.step == 'practice') {
        to = 'lesson.practice';
      } else if (this.step == 'listening_practice') {
        to = 'lesson.listening.practice';
      } else {
        to = 'lesson.exam';
      }
      this.$router.go({name: to})
    },

    completedLesson() {
    },
    
    audioPlayEvent: function(value) {
      if(this.driver) {
        this.driver.reset();
        
      }
    },
    initCoachMark() {
      if(this.driver) {
        this.driver.reset()
      } else {
        const driverOverlay = document.getElementById('driver-page-overlay')
        const driverStage = document.getElementById('driver-highlighted-element-stage')
        const driverItem = document.getElementById('driver-popover-item')
        const driverItem2 = document.getElementById('driver-popover-item2')
        
        if(driverOverlay) {
          driverOverlay.remove()
        }
        if(driverStage) {
          driverStage.remove()
        }
        if(driverItem) {
          driverItem.remove()
        }
      }
    },
    showCoachMark() {
      let self = this;
      
      if(!this.authUser) return false;
      
      if(this.authUser.language == 'ja') return false;

      this.hasAudioEl = (this.quiz && this.isListening && this.audios.length && this.audioType == 'audio')

      this.driver = new Driver({
          className: "scoped-class-dark",
          animate: true,
          opacity: 0.7,
          padding: 10,
          allowClose: true,
          overlayClickNext: false,
          DoneBtnText: "Done",
          CloseBtnText: "Close",
          NextBtnText: "Next",
          PrevBtnText: "Previous step",
          onDeselected: (e) => {
            if(this.hasAudioEl) {
              if(this.driver.hasNextStep()) {
                return false
              }
            }
          },
          onNext: (e) => {
            if(this.hasAudioEl) {
              this.coachStep ++
            }
          },
          onReset: (e) => {
            console.log("A:"+self.hasAudioEl)
            console.log("A2:"+this.hasAudioEl)
            if(this.hasAudioEl) {
              this.coachStep ++
              if(this.driver.hasNextStep()) {
                if((e &&'popover' in e) && !e.popover.node.classList.contains('popover-last')) {
                  
                  setTimeout(() => {
                    this.driver.start(1);
                  }, 500)
                  return true
                }
              }
            }
            if(e &&'node' in e) {
              const $node = $(e.node);
              if($node.hasClass('button-next-done') || $node.hasClass('driver-close-btn') || $node.hasClass('driver-highlighted-element')) {
                this.progress = (100/this.questions.length);
                if (!this.isListening) {
                  setTimeout(() => {
                    this.countTime();
                  }, 1000);
                }
              }
            }
            
            let coachMarks = JSON.parse(this.storage.getItem("coachmarkdone")|| null);
            if(!coachMarks) {
              coachMarks = {};
              coachMarks[this.step] = true;
            } else {
              coachMarks[this.step] = true;
            }

            this.storage.setItem("coachmarkdone", JSON.stringify(coachMarks));
          },
      })
      
      if(this.hasAudioEl) {
        this.driver.defineSteps([
        {
          element: ".box-question-explanation",
          popover: {
            className: 'popover-class show-button',
            title: "Tap the question to see the translation",
            position:  "bottom",
            offset: 0
          }
        },
        {
            element: '.buttons-audio',
            popover: {
            className: 'popover-class show-button popover-last title-left footer-left',
              title: 'click to Play',
              position: 'top',
            }
          }
        ]);
      }
      
      
      setTimeout(() => {
        if(this.hasAudioEl) {
          this.driver.start();
        } else {
          this.driver.highlight({
            element: ".box-question-explanation",
            popover: {
              className: 'popover-class',
              title: "Tap the question to see the translation",
              position:  "bottom",
              offset: 0
            }
          })
        }
      },300)
    }
  }
}
</script>

<style scoped lang="scss">
.base-timer {
  position: relative;
  width: 75px;
  height: 75px;
  margin: 10px auto; // new
  &__circle {
    fill: none;
    stroke: none;
  }
  &__path-elapsed {
    stroke-width: 7px;
    stroke:grey;
    stroke: #e0e0e0;
  }
  &__label {
    position: absolute;      
    width: 75px;
    height: 75px;
    top: 0; 
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }
  &__path-remaining {
    stroke-width: 7px;
    stroke-linecap: round;
    transform: rotate(90deg);
    transform-origin: center;
    transition: 1s linear all;
    stroke: rgb(65, 184, 131); // green
  }
  &__svg {
    transform: scaleX(-1);
  }
  &__path-remaining {
    stroke-width: 7px;
    stroke-linecap: round;
    transform: rotate(90deg);
    transform-origin: center;
    transition: 1s linear all;
    fill-rule: nonzero;
    stroke: currentColor;
    &.green {
      color: rgb(65, 184, 131);
    }
    &.orange {
      color: orange;
    }
    &.red {
      color: red;
    }
  }
}
</style>